module.exports = __webpack_public_path__ + "img/eat.93151f2f.png";